import moment from "moment";

export default {
  install (Vue, options) {
    if (process.env.VUE_APP_DEVELOPMENT_MENU !== "ON") return;

    const originalErrorHandler = Vue.config.errorHandler;

    Vue.config.errorHandler = (err, vm, info) => {
      vm.$store.commit("app/addError", {
        from: "errorHandler",
        message: err.message,
        stack: err.stack,
        vm: vm,
        info: info,
        datetime: now(),
        view: view(vm.$store),
      });

      if (originalErrorHandler) {
        originalErrorHandler.call(this, err, vm, info);
      } else {
        const name = vm.$options.name || vm.$options._componentTag;
        console.error(`in <${name} />\n`, err);
      }
    };

    window.addEventListener("error", (event) => {
      options.store.commit("app/addError", {
        from: "window.onerror",
        message: event.message,
        stack: event.error.stack,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error,
        datetime: now(),
        view: view(options.store),
      });
    });

    window.addEventListener("unhandledrejection", (event) => {
      options.store.commit("app/addError", {
        from: "window.onunhandledrejection",
        message: event.reason.message,
        stack: event.reason.stack,
        error: event.reason,
        datetime: now(),
        view: view(options.store),
      });
    });
  },
};

function now() {
  return moment().format("YYYY-MM-DD HH:mm:ss");
}

function view(store) {
  const view = store.getters["app/getCurrentView"];
  const table = store.getters["app/getCurrentTable"];
  const level = store.getters["app/getCurrentLevel"];

  return [view, table, level].filter((arg) => arg).join(" ");
}
